import React, { useEffect, useState } from "react";
import Home from './components/Home/Home';
import Header from "./components/layout/Header/Header";
// import { BrowserRouter, Routes, Route, useLocation, useRouteMatch, Link, Router } from 'react-router-dom';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import Cart from "./components/Pages/cartpage/Cart";
import AllProducts from "./components/Pages/productPages/AllProducts";
import ProductDetails from "./components/Pages/productPages/ProductDetails";
import Wishlist from "./components/Pages/wishlistPages/Wishlist";
// import SideBar from "./components/layout/Modal/sidebar/SideBar";
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import CustomCursorComponent from "./CustomCursorComponent";
import { isLoggedIn } from "./authUtils";
import CouponPage from "./components/Pages/NotificationPage/CouponInfo";
import OrderDetails from "./components/Pages/OrderPages/OrderDetails";
import Payment from "./components/Pages/Paymentpages/Payment";
import AllAddresses from "./components/Pages/addressPages/AllAddresses";
import Explore from "./components/Pages/explorePage/Explore";
import ExclusiveProductPage from "./components/Pages/productPages/Exclusive Product Pages/ExclusiveProductPage";
import SearchedProducts from "./components/Pages/productPages/SearchedProducts";
import Account from "./components/Pages/userPages/Account";
import AccountMobileView from "./components/Pages/userPages/AccountMobView";
import UserProfile from "./components/Pages/userPages/UserProfile";
import LoginSignUpModal from "./components/layout/Modal/LoginSignUpModal";
import { updateCart } from "./redux/actions/cartAction";

//for LOGIN/SIGNUP modal

const useStyles = makeStyles({
  dialogPaper: {
    borderRadius: '12px !important',
    width: '800px',
    height: '550px',
    maxWidth: '1200px !important',
    maxHeight: '900px',
    transform: 'scale(1)',
    transition: 'transform 0.5s ease-in-out',
    boxShadow: 'none !important',
    backgroundColor: '#fff',
    padding: '0 !important',
    
  },
  
 
  '@media (max-width: 600px)': {
    dialogPaper: {
      // CSS styles specific to max-width 600px
      // For example:
      width: '100vw',
      height: '100vh',
      maxWidth: 'none',
      maxHeight: 'none',
      padding: 0,
      margin: 0,
      margin: '0 !important', // Override margin
      maxHeight: '100% !important', // Override max-height
      borderRadius: '0 !important',
      
    },
  },
});






function App() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    setLoggedIn(isLoggedIn());
}, []); // Call the function here to get the result
  
console.log('LOGGEDIN?', loggedIn);
  
  //for SIGNUP/LOGIN fuctions
  const  currentUser = useSelector((state) => state.currentUser);
  console.log(currentUser);

 
 

  const [signinModalOpen, setSigninModalOpen] = useState(false);
  const [formType, setFormType] = useState('');
  const [networkStatus, setNetworkStatus] = useState(null);
  const [alert, setAlert] = useState(null);
  const [backConfirmModal, setBackConfirmModal] = useState(false);

  const showBackConfirmModal = () => {
    setBackConfirmModal(true);
  }

  const hideBackconfirmModal = () => {
    setBackConfirmModal(false);
  }

  // const goBackConfirm = () => {
  //   navigate('/');
  //   setBackConfirmModal(false);
  // }
  
  const handleFormType = (type) => {
    setFormType(type);
  }
  // useEffect(() => {
  //   setLoggedIn(isLoggedIn);
  // }, [isLoggedIn]);
 
  

console.log('loggedIn'.loggedIn);

// useEffect(() => {
//   const popupShown = localStorage.getItem('popupShown');

//   if (!loggedIn && !popupShown) {
//     const timeout = setTimeout(() => {
//       setSigninModalOpen(true);
//       localStorage.setItem('popupShown', 'true');
//     }, 3000); // Change the timeout duration as needed (e.g., 3000ms for 3 seconds)

//     return () => clearTimeout(timeout);
//   }
// }, []);


  const slModalOpen = () => {
    setSigninModalOpen(true);
  };

  console.log('modal Open?', signinModalOpen)
  const slModalClose = () => {
    console.log('Modal Close func. Called!');
    setSigninModalOpen(false);
  };


  window.ononline = (event) => {
    console.log('Back to Online');
  }

  window.onoffline = (event) => {
    console.log('Connection Lost');
  }

  // const[sidebar, setSideBar] = useState(false);

  //     const toggleSideBar = () => {
  //       setSideBar((prevState) => !prevState)
  //     }


  // React.useEffect(() => {
  //   WebFont.load({
  //     google: {
  //       families: ["Roboto", "Cinzel Decorative", "Pinyon Script", "Open Sans", "Sans-Serif", "Great Vibes", "Satisfy", "Cursive", 
  //       "Spectral", 'Tangerine', 'Philosopher', 'Questrial', 'Kumbh Sans', 'MonteCarlo', 'Send Flowers', 'Yesteryear', 'Italianno', 
  //       'Charm', 'Trirong', 'Noto Serif Display', 'Sail', 'Bellefair', 'Prata', 'Gloock', 'Yeseva One', 'DM Sans', 'DM Serif Display']
  //     }
  //   });

  //   // store.dispatch(userInfo());

  // }, []);


  useEffect(() => {
    dispatch(updateCart());
  }, [loggedIn])


  // useEffect(() => {
  //   window.addEventListener('online', () => setNetworkStatus(navigator.onLine))
  //   return () => window.removeEventListener('online', () => setNetworkStatus(navigator.onLine))
  // })

  useEffect(() => {
    function changeStatus() {
      setNetworkStatus(navigator.onLine);
    }
    window.addEventListener("online", changeStatus);
    window.addEventListener("offline", changeStatus);
    return () => {
      window.removeEventListener("online", changeStatus);
      window.removeEventListener("offline", changeStatus);
    };
  }, [networkStatus]);

  const href = window.location.pathname;


  const showAlert = (type, message) => {
    console.log('Alert:', type, message);
    setAlert({ type, message });
    setTimeout(() => {
      setAlert(null);
    }, 2000); // Hide the alert after 3 seconds
  };

  

  console.log(formType);
  console.log(slModalOpen);
  

  return (
    <div className="App no-scrollbar">
      <CustomCursorComponent />
        <Router>
      <Header slModalOpen={slModalOpen} handleFormType={handleFormType} slModalClose={slModalClose} loggedIn={loggedIn}/> 
      {/* <NavBar slModalOpen={slModalOpen} handleFormType={handleFormType} slModalClose={slModalClose} loggedIn={loggedIn}/> */}
      {signinModalOpen &&
      <LoginSignUpModal slModalClose={slModalClose} setSigninModalOpen={setSigninModalOpen} setLoggedIn={setLoggedIn}/>}
        
      <Routes>
        <Route path="/" element={<Home />} loggedIn={loggedIn}/>
        <Route path="/products" element={<AllProducts />} loggedIn={loggedIn}/>
        <Route exact path="/product/:slug" element={<ProductDetails loggedIn={loggedIn}/>} />
        <Route exact path="/search" element={<SearchedProducts />} loggedIn={loggedIn}/> 
        <Route exact path="/search" element={<SearchedProducts />} loggedIn={loggedIn}/> 
        <Route exact path="/cart" element={<Cart />} loggedIn={loggedIn}/>
        <Route exact path="/wishlists" element={<Wishlist loggedIn={loggedIn}/>} />
        <Route exact path="/checkout/address" element={<AllAddresses />} loggedIn={loggedIn}/>
        <Route exact path="/checkout/payment" element={<Payment />} loggedIn={loggedIn}/>
        <Route exact path="/explore" element={<Explore />}/>
        <Route exact path="/orders" element={<OrderDetails />}/>
        {window.innerWidth < 600 && <Route exact path='/mv/account' element={<AccountMobileView slModalOpen={slModalOpen}/>} />}
        <Route exact path="coupons" element={<CouponPage slModalOpen={slModalOpen}/>} />
        <Route path="/exclusive" element={<ExclusiveProductPage />} />
        {/* Define more routes here */}
        <Route exact path='/account' element={<Account currentUser={currentUser}/>} slModalOpen={slModalOpen}>
            <Route exact path='your-profile' element={<UserProfile slModalOpen={slModalOpen}/>} />
            <Route exact path="addresses" element={<AllAddresses slModalOpen={slModalOpen}/>} />
            {/* <Route exact path="savedcards" element={<CardDetails />} /> */}
            {/* <Route exact path="savedUPIs" element={<UpiDetails />} /> */}
            {/* <Route exact path="your-notifications" element={<NotificationDetails slModalOpen={slModalOpen}/>} /> */}
            <Route exact path="coupons" element={<CouponPage slModalOpen={slModalOpen}/>} />
            <Route exact path="wishlists" element={<Wishlist slModalOpen={slModalOpen}/>} />
          </Route>
      </Routes>
    </Router>




    {/* <GlobalErrorBoundary> */}
      {/* <BrowserRouter> */}
        {/* space for Back confirmation modal */}

        {/* <Dialog onClose={hideBackconfirmModal}
          open={backConfirmModal}
          classes={{ paper: classes.dialogModal }}
          BackdropProps={{
            style: { backgroundColor: 'rgba(98,60,33,.4)', backdropFilter: 'blur(8px)'},
          }}
        >
            <DialogContent>
                <span>Are you sure?</span>
                <span>You want to go back</span>
            </DialogContent>
            <div>
                <div className='back_modal_action_btns'>
                    <button>
                      <Link to='/'>Back</Link>
                    </button>
                    <button onClick={hideBackconfirmModal}>Cancel</button>
                </div>
            </div>
        </Dialog> */}

        {/* space for SIGNUP/LOGIN modal */}
        {/* <Dialog onClose={slModalClose}
          open={signinModalOpen}
          classes={{ paper: classes.dialogPaper }}
          BackdropProps={{
            style: { backgroundColor: 'rgba(98,60,33,.4)', backdropFilter: 'blur(8px)'},
          }}>
          
            <DialogContent>
              <div className="dialog_cont_2_bx">
                <div className="lgin_popup_dialog_left">
                  <div>SignUp/Login</div>
                  <div className="lgin_popUp_close_btn" onClick={slModalClose}>
                   <CloseRoundedIcon style={{color: '#fff'}}/>
                  </div>
                  
         
                </div>
                <div className="lgin_popup_dialog_right">
                <SignInSignupComponent slModalClose={slModalClose} showAlert={showAlert}/>
                </div>
              </div>
            </DialogContent>
          </Dialog>
          <div className="alert_wrap">
            {alert && <Alert type={alert.type} message={alert.message} showAlert={showAlert} />}
          </div>


        <Header slModalOpen={slModalOpen} handleFormType={handleFormType} loggedIn={loggedIn} showBackConfirmModal={showBackConfirmModal}/>
        <Routes>
            <Route exact path="/" element={<Home />} />
            
            <Route exact path='/products' element={<AllProducts />} />
            <Route exact path='/:collectionSlug' element={<ProductsByCollectionPage />} />
            <Route exact path='/pl/search' element={<AllProducts />} />
            <Route exact path='/premium' element={<PremiumProducts />} />
            <Route exact path='/cart' element={<Cart slModalOpen={slModalOpen}/>} />
            <Route exact path='/explore' element={<Explore />} />
            <Route exact path="/product/:slug" element={<ProductDetails />} />
            <Route exact path='/login' element={<Login />} />
            {window.innerWidth < 600 && <Route exact path='/search' element={<MobileSearchPage />} />}
            {window.innerWidth < 600 && <Route exact path='/mv/account' element={<AccountMobView slModalOpen={slModalOpen}/>} />}
            <Route exact path='/policy' element={<CompanyPolicy />} />
            <Route path='/account/your-orders' element={<YourOrder currentUser={currentUser} slModalOpen={slModalOpen}/>} />
            <Route path='/order-details' element={<OrderDetails />} slModalOpen={slModalOpen}/>
            <Route path='/notifications' element={<AllNotifications slModalOpen={slModalOpen}/>} />
            <Route path='/coupons' element={<Allcoupons slModalOpen={slModalOpen}/>} />
            
          
          <Route exact path='/account' element={<Account currentUser={currentUser}/>} slModalOpen={slModalOpen}>
            <Route exact path='your-profile' element={<UserProfile slModalOpen={slModalOpen}/>} />
            <Route exact path="addresses" element={<AllAddresses slModalOpen={slModalOpen}/>} />
            <Route exact path="savedcards" element={<CardDetails />} />
            <Route exact path="savedUPIs" element={<UpiDetails />} />
            <Route exact path="your-notifications" element={<NotificationDetails slModalOpen={slModalOpen}/>} />
            <Route exact path="coupons" element={<CouponInfo slModalOpen={slModalOpen}/>} />
            <Route exact path="wishlists" element={<Wishlist slModalOpen={slModalOpen}/>} />
          </Route>

          <Route exact path='/terms' element={<CompanyTerms />} >
            <Route exact path='/terms/orderCancellation' element={<OrderCancellation />} />
            <Route exact path='/terms/returnAndRefunds' element={<ReturnAndRefund />} />
            <Route exact path="/terms/privacy" element={<Privacy />} />
            <Route exact path="/terms/security" element={<Security />} />
            <Route exact path="/terms/termsOfUse" element={<TermsOfUse />} />
          </Route> */}


          
          {/* <Route exact path='/checkout' element={<CheckoutPage slModalOpen={slModalOpen}/>} />
          <Route exact path='/payment' element={<Payment />} slModalClose={slModalClose}/>
          <Route exact path='/order-status' element={<OrderPlaced currentUser={currentUser}/>} slModalClose={slModalClose}/>
          <Route path="*" element={<NotFound />} />
        </Routes> */}
        {/* <Footer/> */}
        {/* <div className='network_status'>
          {networkStatus ? <div style={{ borderRadius: '5px', width: '100vw', bottom: 0, position: "fixed", background: 'green', padding: '15px', zIndex: '9999', color: '#fff', left: '0' }}>Network Connected</div> : <div style={{ borderRadius: '5px', width: '100vw', left: '0', bottom: 0, position: "absolute", background: 'red', padding: '15px', zIndex: '9999', position: "fixed", }}>Network Disconnected</div>}
        </div> */}
      {/* </BrowserRouter> */}
      {/* </GlobalErrorBoundary> */}
    </div>

  );
}

export default App;
